"use strict";
import PerfectScrollbar from 'perfect-scrollbar';

Vue.component("bsnMenuItem", {
   data: () => {
       return {
           menuIsOpen: false
       }
   },
    methods: {
        toggleMenu: function () {
            this.$data.menuIsOpen = !this.$data.menuIsOpen;
        }
    }
});

Vue.component("bsnMenu", {

    data: () => {
        return {
            textBeforeBurgerBtn: "M",
            textAfterBurgerBtn: "NU",
            menuIsOpen: false,
            searchFormIsOpen: false,
            dropDownIsOpen: false,
            body: document.querySelector("body")
        }
    },

    methods: {
        toggleMenu: function () {
            if (this.menuIsOpen) {
                this.$data.textBeforeBurgerBtn = "M";
                this.$data.textAfterBurgerBtn = "NU";
                this.$data.body.style.overflowY = "auto";
            } else {
                this.$data.textBeforeBurgerBtn = "E";
                this.$data.textAfterBurgerBtn = "IT";
                this.$data.body.style.overflowY = "hidden";
            }
            this.$data.menuIsOpen = !this.$data.menuIsOpen;
        },

        toggleSearchForm: function () {
            this.$data.searchFormIsOpen = !this.$data.searchFormIsOpen;
        },

        toggleDropDown: function () {
            this.$data.dropDownIsOpen = !this.$data.dropDownIsOpen;
        }
    },

    mounted: function() {
        let container = document.querySelector('#menu-scroll-container');
        let ps = new PerfectScrollbar(container, {
            wheelSpeed: 2,
            wheelPropagation: true,
            minScrollbarLength: 20,
            suppressScrollX: false
        });
    }
});



// WEBPACK FOOTER //
// ./frontend/js/menu.js